import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import format from 'date-fns/format';
import { InfoOutlined } from '@material-ui/icons';
import Input, { INPUT_TYPES } from '../Input/Input';

const ChannelingToggleChangesetRow = props => {
  const { rowKey, draft, totalApprovals } = props;
  const status = draft.status ? 'Deactivate' : 'Activate';

  return (
    <tr
      className={cx('b-2-white', 'bg-lightYellow')}>
      <td className="p-2">
        <Input
          id={draft.id}
          name={draft.id}
          type={INPUT_TYPES.CHECKBOX}
          onChange={event => props.toggleRowSelection(event, draft)}
          checked={props.selected[rowKey]}
          inputClassName="box_checkbox"
        />
      </td>
      <td className="p-2">{draft.modified_by}</td>
      <td className="p-2">{format(new Date(draft.modified_at), 'd MMM yyyy')}</td>
      <td className="p-2">{draft.channel_type}</td>
      <td className="p-2">{status}</td>
      <td className="draft_approvers p-2">
        <span>{`${totalApprovals}/2`}</span>
        {Boolean(totalApprovals) && (
          <InfoOutlined className="cursor-pointer" fontSize="small" />
        )}
        {Boolean(totalApprovals) && (
          <span className="draft_approvers__list">
            {draft.first_approver}, {draft.second_approver}
          </span>
        )}
      </td>
    </tr>
  );
};

ChannelingToggleChangesetRow.propTypes = {
  rowKey: PropTypes.string.isRequired,
  draft: PropTypes.object.isRequired,
  selected: PropTypes.object.isRequired,
  totalApprovals: PropTypes.number.isRequired,
  toggleRowSelection: PropTypes.func.isRequired,
};

export default  ChannelingToggleChangesetRow;
